import { useEffect, useState } from "react";
import LocationsApi from "../../api/LocationsApi";
import { getMultiLocationDesignsPerPage } from "../../service/DsaService";
import { DesignView } from "./EditScreenContentModal";

export function useMultiLocationDesigns(locationIds: number[], enabled: boolean = true) {
  const [designs, setDesigns] = useState([] as DesignView[]);
  const [loading, setLoading] = useState(false);

  const key = [...locationIds].sort((a, b) => a - b).join(",");

  useEffect(() => {
    if (!enabled || locationIds.length === 0) {
      setDesigns([]);
      return;
    }

    let active = true;
    setLoading(true);
    LocationsApi.getLocationDesignsMulti(locationIds)
      .then(resp => {
        if (!active) return;
        setDesigns(getMultiLocationDesignsPerPage(resp.data));
      })
      .finally(() => {
        if (active) setLoading(false);
      });

    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, enabled]);

  return { designs, loading };
}
